import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';
import infoIcon from '../../assets/info.svg';

const RevokeMessage = (props) => {
	const { t } = useTranslation();
	const theme = useTheme();
	const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('lg'));
	const isDark =
		props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';

	const primaryColor = props.customDetails?.primaryColor || '#4A5EAD';
	const backgroundColor = isDark
		? '#2D2D2D'
		: `color-mix(in srgb, ${primaryColor} 10%, transparent)`;

	const aaHandle = global.userId || '';
	const isExpired = props.consentStatus === 'EXPIRED';
	const messageKey = isExpired
		? 'common.messages.revokeMessageExpired'
		: 'common.messages.revokeMessage';

	return (
		<Box
			sx={{
				fontFamily: props.customDetails?.fontFamily,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'flex-start',
				gap: isMobileOrTablet ? '4px' : '5px',
				backgroundColor: backgroundColor,
				padding: isMobileOrTablet ? '10px 12px' : '12px 16px',
				borderRadius: '8px',
				width: isMobileOrTablet ? '90%' : '50%',
				margin: '0 auto',
				overflow: 'hidden',
			}}
		>
			{/* <img
				src={infoIcon}
				alt="info"
				style={{
					flexShrink: 0,
					width: isMobileOrTablet ? '16px' : '20px',
					height: isMobileOrTablet ? '16px' : '20px',
					display: 'block',
				}}
			/> */}
			<Typography
				variant="body1"
				sx={{
					wordWrap: 'break-word',
					overflowWrap: 'break-word',
					fontSize: isMobileOrTablet ? '0.8rem' : '1rem',
					fontFamily: props.customDetails?.fontFamily,
					margin: 0,
					padding: 0,
					textAlign: 'left',
					color: '#6C6C6C',
				}}
			>
				{`${t(messageKey)} ${aaHandle}.`}
			</Typography>
		</Box>
	);
};

export default RevokeMessage;
